module.exports = __webpack_public_path__ + "static/media/img_20.99a3cefd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_20.jpg
// module id = 539
// module chunks = 0